import {Component, Input} from '@angular/core';
import {IncidentResponse, IncidentType} from '@npck/af-frontend-api';

@Component({
    selector: 'af-incident-details-tab',
    templateUrl: 'incident-details-tab.component.html',
    styleUrls: ['incident-details-tab.component.scss'],
    standalone: false,
})
export class IncidentDetailsTabComponent {
    @Input() incident: IncidentResponse;
    @Input() transactionId: string;
    Number = Number;

    get showAmountDetails(): boolean {
        return this.incident?.typeCode !== IncidentType.OTHER
            && this.incident?.typeCode !== IncidentType.MSISDN_FRAUD;
    }
}
